
import {
  Sidebar,
  SidebarContent,
} from "@/components/ui/sidebar";
import { SidebarMain } from "./sidebar/SidebarMain";
import { cn } from "@/lib/utils";

export function AppSidebar() {
  return (
    <Sidebar
      collapsible="none"
      className={cn(
        "bg-[#23486a] text-white h-full w-full border-0",
        "[&[data-mobile=true]]:!bg-[#23486a] [&[data-mobile=true]]:!text-white"
      )}
    >
      <SidebarContent className="p-0">
        <SidebarMain />
      </SidebarContent>
    </Sidebar>
  );
}
